<mat-card *kienePermission="[3201]" style="margin-bottom: 20px">
    <div style="width: 100%">
        <h5>Verkauf</h5>
        <table class="phito-table">
            <thead>
                <tr>
                    <th>VK</th>
                    <th>Verkaufspreis Netto</th>
                    <ng-container *kienePermission="[3205]">
                        <th>Handelsspanne %</th>
                        <th>Rohertrag</th>
                        <th>Kalkulationszuschlag %</th>
                        <th>Brutto VK {{ vat }}%</th>
                    </ng-container>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let mp of materialPrices; let i = index">
                    <td [attr.data-cy]="'mmpmp_td_1_5_'">{{ mp.verkaufspreis }}</td>
                    <td [attr.data-cy]="'mmpmp_td_2_5_'">
                        <mat-form-field>
                            <mat-label>Einzelpreis</mat-label>
                            <input
                                matInput
                                type="number"
                                [formControl]="vkCtrls[mp.verkaufspreis_id + '_' + mp.artikel_id]"
                                [attr.data-cy]="'mmpmp_input_1_1_' + i"
                            />
                            <span matSuffix>&euro;</span>
                        </mat-form-field>
                    </td>
                    <ng-container *kienePermission="[3205]">
                        <td [attr.data-cy]="'mmpmp_td_3_5_'"
                            >{{
                                gibHandelsspanne(vkCtrls[mp.verkaufspreis_id + "_" + mp.artikel_id]?.value)
                                    | number: "2.2-2"
                            }}%</td
                        >
                        <td [attr.data-cy]="'mmpmp_td_4_5_'"
                            >{{
                                gibRohertrag(vkCtrls[mp.verkaufspreis_id + "_" + mp.artikel_id]?.value)
                                    | number: "2.2-2"
                            }}€</td
                        >
                        <td [attr.data-cy]="'mmpmp_td_5_5_'"
                            >{{
                                gibKalkulationszuschlag(vkCtrls[mp.verkaufspreis_id + "_" + mp.artikel_id]?.value)
                                    | number: "2.2-2"
                            }}%</td
                        >
                        <td [attr.data-cy]="'mmpmp_td_6_5_'"
                            >{{
                                gibBruttoVK(vkCtrls[mp.verkaufspreis_id + "_" + mp.artikel_id]?.value)
                                    | number: "2.2-2"
                            }}€</td
                        >
                    </ng-container>
                </tr>
                <!-- <tr>
              <td [attr.data-cy]="'mmpmp_td_7_5_'">2</td>
              <td [attr.data-cy]="'mmpmp_td_8_5_'"><mat-form-field>
                <input matInput type="number" [formControl]="vk2Ctrl" placeholder="Verkaufspreis 2" [attr.data-cy]="'mmpmp_input_2_1_'">
                <span matSuffix>&euro;</span>
              </mat-form-field></td>
              <td [attr.data-cy]="'mmpmp_td_9_5_'">{{gibHandelsspanne(vk2Ctrl.value) | number: '2.2-2'}}%</td>
              <td [attr.data-cy]="'mmpmp_td_10_5_'">{{gibRohertrag(vk2Ctrl.value) | number: '2.2-2'}}€</td>
              <td [attr.data-cy]="'mmpmp_td_11_5_'">{{gibKalkulationszuschlag(vk2Ctrl.value) | number: '2.2-2'}}%</td>
              <td [attr.data-cy]="'mmpmp_td_12_5_'">{{gibBruttoVK(vk2Ctrl.value) | number: '2.2-2'}}€</td>
            </tr>
            <tr>
              <td [attr.data-cy]="'mmpmp_td_13_5_'">3</td>
              <td [attr.data-cy]="'mmpmp_td_14_5_'"><mat-form-field>
                <input matInput type="number" [formControl]="vk3Ctrl" placeholder="Verkaufspreis 3" [attr.data-cy]="'mmpmp_input_3_1_'">
                <span matSuffix>&euro;</span>
              </mat-form-field></td>
              <td [attr.data-cy]="'mmpmp_td_15_5_'">{{gibHandelsspanne(vk3Ctrl.value) | number: '2.2-2'}}%</td>
              <td [attr.data-cy]="'mmpmp_td_16_5_'">{{gibRohertrag(vk3Ctrl.value) | number: '2.2-2'}}€</td>
              <td [attr.data-cy]="'mmpmp_td_17_5_'">{{gibKalkulationszuschlag(vk3Ctrl.value) | number: '2.2-2'}}%</td>
              <td [attr.data-cy]="'mmpmp_td_18_5_'">{{gibBruttoVK(vk3Ctrl.value) | number: '2.2-2'}}€</td>
            </tr>
            <tr>
              <td [attr.data-cy]="'mmpmp_td_19_5_'">4</td>
              <td [attr.data-cy]="'mmpmp_td_20_5_'"><mat-form-field>
                <input matInput type="number" [formControl]="vk4Ctrl" placeholder="Verkaufspreis 4" [attr.data-cy]="'mmpmp_input_4_1_'">
                <span matSuffix>&euro;</span>
              </mat-form-field></td>
              <td [attr.data-cy]="'mmpmp_td_21_5_'">{{gibHandelsspanne(vk4Ctrl.value) | number: '2.2-2'}}%</td>
              <td [attr.data-cy]="'mmpmp_td_22_5_'">{{gibRohertrag(vk4Ctrl.value) | number: '2.2-2'}}€</td>
              <td [attr.data-cy]="'mmpmp_td_23_5_'">{{gibKalkulationszuschlag(vk4Ctrl.value) | number: '2.2-2'}}%</td>
              <td [attr.data-cy]="'mmpmp_td_24_5_'">{{gibBruttoVK(vk4Ctrl.value) | number: '2.2-2'}}€</td>
            </tr>
            <tr>
              <td [attr.data-cy]="'mmpmp_td_25_5_'">5</td>
              <td [attr.data-cy]="'mmpmp_td_26_5_'"><mat-form-field>
                <input matInput type="number" [formControl]="vk5Ctrl" placeholder="Verkaufspreis 5" [attr.data-cy]="'mmpmp_input_5_1_'">
                <span matSuffix>&euro;</span>
              </mat-form-field></td>
              <td [attr.data-cy]="'mmpmp_td_27_5_'">{{gibHandelsspanne(vk5Ctrl.value) | number: '2.2-2'}}%</td>
              <td [attr.data-cy]="'mmpmp_td_28_5_'">{{gibRohertrag(vk5Ctrl.value) | number: '2.2-2'}}€</td>
              <td [attr.data-cy]="'mmpmp_td_29_5_'">{{gibKalkulationszuschlag(vk5Ctrl.value) | number: '2.2-2'}}%</td>
              <td [attr.data-cy]="'mmpmp_td_30_5_'">{{gibBruttoVK(vk5Ctrl.value) | number: '2.2-2'}}€</td>
            </tr> -->
            </tbody>
        </table>
    </div>
    <mat-card-actions style="text-align: right">
        <span class="spacer"></span>
        <button
            *ngIf="isAdmin"
            mat-stroked-button
            color="primary"
            (click)="openHistorieDialog()"
            [disabled]="material.artikel_id === null || material.artikel_id === undefined"
            [attr.data-cy]="'mmpmp_button_1_0_'"
            >Historie öffnen
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="savePrices()"
            [disabled]="material.artikel_id === null || material.artikel_id === undefined"
            [attr.data-cy]="'mmpmp_button_2_0_'"
            >Speichern</button
        >
    </mat-card-actions>
</mat-card>
